import { render, staticRenderFns } from "./GroepsInstellingenActions.vue?vue&type=template&id=0a135868&"
import script from "./GroepsInstellingenActions.vue?vue&type=script&lang=js&"
export * from "./GroepsInstellingenActions.vue?vue&type=script&lang=js&"
import style0 from "./GroepsInstellingenActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports